import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';

export interface OrganizationState {
  organizationName: string | null;
}

export const selectOrganizationState = createFeatureSelector<OrganizationState>('organization');

export const selectOrganizationName: MemoizedSelector<object, string | undefined> = createSelector(
  selectOrganizationState,
  state => (state.organizationName ? state.organizationName : undefined)
);
